import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { TransportDriver } from "types/TransportDriver";
import TransportDriverLastLocationMap from "./TransportDriverLastLocationMap";

type Props = {
  transportDriver: TransportDriver;
};

export default function TransportDriverInfo({ transportDriver }: Props) {
  const { vehicles, lastLocation } = transportDriver;
  console.log(transportDriver);
  return (
    <Grid container xl>
      <Grid item sm={7} p={1}>
        <Typography variant="h6" component="h2">
          {transportDriver.user.name} - {transportDriver.user.phone}
        </Typography>
        <Typography variant="h6" component="h2">
          Vehiculos
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={{ width: "100%" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Placa</TableCell>
                <TableCell>Modelo</TableCell>
                <TableCell>Color</TableCell>
                <TableCell>Año</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vehicles.map((vehicle) => (
                <TableRow key={vehicle.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    <img src={vehicle?.vehicleType?.icon} style={{ height: 32 }} />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {vehicle.plate}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {vehicle.model}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {vehicle.color}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {vehicle.year}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item sm={5}>
        <TransportDriverLastLocationMap location={lastLocation} />
      </Grid>
    </Grid>
  );
}
